import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i3.22
import React from 'react';
import IconWrap from '../IconWrap';
const LinkArrow = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M19.8557 11.5392a.4635.4635 0 0 1-.1518.1518l-5.9296 4.4512a.4635.4635 0 0 1-.6473-.1279.5035.5035 0 0 1-.0799-.2397V13.433s-4.0037-1.1028-8.231 3.8838a.4635.4635 0 0 1-.6554.048.4715.4715 0 0 1-.1598-.3836C4.2007 14.5839 6.566 8.79 13.031 8.79V6.4407a.4715.4715 0 0 1 .5035-.4395.5034.5034 0 0 1 .2397.0799l5.9296 4.4512a.7112.7112 0 0 1 .1518 1.0069z"
    })));
LinkArrow.displayName = 'LinkArrow';
export default LinkArrow;
